var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',[_vm._v(_vm._s(_vm.companyName)+" "+_vm._s(_vm.$t('report.monthReport'))+" - "+_vm._s(_vm.month))]),_vm._v(" "),_c('h5',[_vm._v(_vm._s(_vm.subTitle))]),_vm._v(" "),_c('h6',[_vm._v(_vm._s(_vm.date))]),_vm._v(" "),_c('h6',[_vm._v(_vm._s(_vm.$t('report.version'))+": "+_vm._s(_vm.version))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55b34d0c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reportItems/CoverPage.vue
// module id = null
// module chunks = 